/**
 * ProductHeader - Displays product name, badges, tagline, and description
 * Pure presentational component wrapped with React.memo
 */

import { memo } from 'react';
import type { ProductProfile } from '../../../types';

interface ProductHeaderProps {
  data: ProductProfile;
}

function ProductHeaderComponent({ data }: ProductHeaderProps) {
  return (
    <div>
      <div className="flex items-center gap-2 mb-2">
        {data.is_flagship && (
          <span className="inline-flex items-center rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-medium text-primary-700">
            Flagship
          </span>
        )}
        {data.is_new && (
          <span className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-700">
            New
          </span>
        )}
        {data.is_sunset && (
          <span className="inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-700">
            Sunset
          </span>
        )}
        {data.segment && <span className="text-sm text-gray-500">{data.segment}</span>}
      </div>
      <h2 id="product-modal-title" className="text-2xl font-bold text-gray-900">
        {data.name}
      </h2>
      {data.tagline && <p className="mt-1 text-lg text-primary-600 italic">{data.tagline}</p>}
      {data.description && <p className="mt-2 text-gray-600">{data.description}</p>}
    </div>
  );
}

export const ProductHeader = memo(ProductHeaderComponent);
